// filepath: apps/web/src/design-system/error-states/SkeletonLayout.tsx
//
// Generic skeleton shown while a definition is loading. The full design
// system is FR-UI-CORE-7/8/9/10 scope; this is a sufficient stub for the
// renderer's 5-error-state binding.
//
// Accepts an optional `data-testid` so callers (KanbanBoard, etc.) can
// surface a surface-specific testid (e.g. `kanban-board--loading`) on
// the root while keeping the primitive's default `form-skeleton` for
// existing consumers.

import React from "react";

export interface SkeletonLayoutProps {
  "data-testid"?: string;
}

export function SkeletonLayout({
  "data-testid": testId = "form-skeleton",
}: SkeletonLayoutProps): React.ReactElement {
  return (
    <div
      data-testid={testId}
      className="form-skeleton"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="skeleton-row skeleton-label" />
      <div className="skeleton-row skeleton-input" />
      <div className="skeleton-row skeleton-label" />
      <div className="skeleton-row skeleton-input" />
      <div className="skeleton-row skeleton-label" />
      <div className="skeleton-row skeleton-input" />
      <span className="visually-hidden">Loading…</span>
    </div>
  );
}
